var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{attrs:{"autocomplete":"off","placeholder":_vm.$t('Add a comment')},on:{"focus":_vm.commentFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }